module.exports = __webpack_public_path__ + "img/dollar-sign-solid.ce02e506.svg";